import { CookieInformation } from 'src/externals/consent/cookie-consent';


export const environment = {
    production: true,
    version: 1,
    klaviyoNewsletterListId: 'VsAW6n',
    consent: CookieInformation.cookieConsentFactory(),
};
